import { VeProgress } from 'vue-ellipse-progress'
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VeProgress', VeProgress)
})
